import { Children } from "react";
import { useNavigate } from "react-router";
import styles from "./header.module.css";

import Back from "../img/back.svg";

export default function Header({
  children,
  isBack = false,
  backCallback = null,
  className = "",
}) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (backCallback == null) {
      // В мини-приложение можно попасть сразу на внутренний экран (deep link
      // из бота) — истории назад нет, тогда открываем /account.
      const idx = window.history.state?.idx ?? 0;
      if (idx > 0) {
        navigate(-1);
      } else {
        navigate("/account", { replace: true });
      }
      return;
    }
    backCallback();
  };

  const classes = [className, styles.headerContainer]
    .filter((x) => x !== "")
    .join(" ");

  return (
    <div className={classes}>
      {isBack && (
        <div
          onClick={handleGoBack}
          className={styles.backIcon + " monochrome-icon"}
        >
          <img src={Back} alt="" />
        </div>
      )}
      {Children.map(children, (child) => (
        <div className={styles.headerText}>{child}</div>
      ))}
    </div>
  );
}
